// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1372":"9b94b50007908186","8369":"0779a25d637faefe"}[chunkId] + ".css";
};